import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box container" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column is-11" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "subtitle is-6" }
const _hoisted_6 = { class: "column is-1" }
const _hoisted_7 = { class: "card-header-icon" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = { class: "notification is-light content" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, " Noticia : " + _toDisplayString(this.news?.title), 1),
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("strong", null, _toDisplayString(this.convertDate( this.news?.created_at)), 1),
          _createTextVNode(". " + _toDisplayString(this.news?.text_intro), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", _hoisted_7, [
          _createVNode(_component_router_link, { to: { name: 'public-news' } }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_svg_icon, {
                  type: "mdi",
                  path: _ctx.mdiArrowLeft
                }, null, 8, ["path"])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("span", {
        innerHTML: this.news?.text_full
      }, null, 8, _hoisted_10)
    ])
  ]))
}